import { Inject, Injectable } from '@angular/core';
import { AuthService } from './auth.service';
import { WindowInjection } from '../window';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ImpersonateService {
  constructor(private authService: AuthService, private router: Router, @Inject(WindowInjection) private window: any) {
    console.log('impersonate is going to be refactored to work with session auth');
  }
}
